import environment from '../../../common/environment';

export function getLtrListUrl(xid: string): string {
  const url = new URL(`${environment().representativeListUrl}`);
  url.searchParams.set('schoolId', extractIdFromXid(xid));
  return url.toString();
}

export function getLtrSchoolListUrl(zipcode: string): string {
  const url = new URL(`${environment().representativeSchoolListUrl}`);
  url.searchParams.set('zipcode', zipcode);
  return url.toString();
}

function extractIdFromXid(xid: string): string {
  const match = RegExp(/organization:([a-f0-9-]{36})$/).exec(xid);
  return match ? match[1] : "";
}